import { useAppDispatch, useAppSelector } from "@/lib/redux/hooks";
import {
  wishlistLineAdd,
  wishlistLineRemove,
} from "@/lib/redux/wishlist/wishlistSlice";
import { SVGDownload, SVGWishlist } from "@/lib/svg";
import { useTranslation } from "@/lib/translations";
import { useRouter } from "next/router";
import React, { useEffect, useMemo } from "react";
import GoBack from "./GoBack";
import Parameter from "./Parameter";
import { ParameterProps } from "./Parameter/Parameter";
import {
  ButtonsWrapper,
  Container,
  Download,
  Heading,
  Parameters,
  ProductDataWrapper,
  ProductType,
  Title,
  Wishlist,
} from "./styles";
import Thumbnail from "./Thumbnail";
import { ImageProps } from "./Thumbnail/Thumbnail";

type Props = {
  product: {
    _id: string;
    catalog: string;
    title: string;
    thumbnail: ImageProps;
    parameters: ParameterProps[];
    typeAttribute: ParameterProps[];
  };
};

const ProductDetail: React.FC<Props> = ({ product }) => {
  const { parameters, typeAttribute, thumbnail, title } = product;

  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log(
      product.thumbnail.asset?.url?.split("/").pop()?.substring(0, 8)
    );
  }, [product.thumbnail.asset?.url]);

  const dispatch = useAppDispatch();
  const wishlist = useAppSelector((state) => state.wishlist);

  const router = useRouter();
  const { locale = "it" } = router;
  const t = {
    downloadPdf: useTranslation("ProductDetail.downloadPdf", locale) || "",
    addWishlist: useTranslation("ProductDetail.addWishlist", locale) || "",
    removeWishlist:
      useTranslation("ProductDetail.removeWishlist", locale) || "",
  };

  const productFoundInWishlist = useMemo(
    function () {
      return wishlist.lines.find((line) => line.productID === product._id);
    },
    [wishlist, product._id]
  );

  return (
    <>
      <GoBack />
      <Container className={"product-detail"}>
        <Heading>
          {typeAttribute && (
            <ProductType as="h2">
              {typeAttribute[0]?.values.join(", ")}
            </ProductType>
          )}
          {title && <Title as="h1">{title}</Title>}
        </Heading>
        {thumbnail && <Thumbnail image={thumbnail} />}
        <ProductDataWrapper>
          <Parameters>
            {parameters &&
              parameters
                .sort((parameterA) => {
                  return parameterA.attribute._id === "ecopositive" ? 1 : -1;
                })
                .map((parameter, index) => (
                  <Parameter
                    key={`${parameter._key}-${index}`}
                    parameter={parameter}
                  />
                ))}
          </Parameters>
          <ButtonsWrapper>
            <Wishlist
              icon={<SVGWishlist />}
              onClick={() => {
                if (product?._id) {
                  if (productFoundInWishlist) {
                    dispatch(wishlistLineRemove(product._id));
                  } else {
                    dispatch(
                      wishlistLineAdd({
                        productID: product._id,
                        productName: title ?? "",
                      })
                    );
                  }
                }
              }}
            >
              {productFoundInWishlist ? t.removeWishlist : t.addWishlist}
            </Wishlist>
            <Download
              href={"/api/product-pdf/" + product._id}
              icon={<SVGDownload />}
              target="_blank"
            >
              {t.downloadPdf}
            </Download>
          </ButtonsWrapper>
        </ProductDataWrapper>
      </Container>
    </>
  );
};

export default ProductDetail;
